<template>
  <div>
    <b-row>
      <b-col md="6" class="my-1">
        <h3 class="text-themecolor">Orders</h3>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="pull-right">
          <b-button variant="themecolor" size="sm" @click="goTo('create')" class="mr-1">
            <i class="fa fa-plus fa-fw" aria-hidden="true"></i> {{$t('buttons.nieuweorder')}}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- User Interface controls -->
            <b-row>
              <b-col md="12" class="my-1">
                <b-form-group class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search'/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- User Interface controls -->
            
            <!-- Main table element -->
            <b-row>
              <b-col md="12">
                <b-table show-empty 
                         :empty-text="getEmptyText(count)"
                         :busy="count == -1"
                         stacked="md"
                         class="table-hover"
                         :items="orders"
                         :fields="fields"
                         :current-page="currentPage"
                         :per-page="perPage"
                         :filter="filter"
                         @filtered="onFiltered"
                         @row-clicked="onRowClicked"> 
                  <template v-slot:cell(status)="data">{{orderStatuses.filter(({key}) => key == data.item.status)[0].value}}</template>
                  <template v-slot:cell(orderDate)="data">{{data.item.orderDate | date}}</template>
                  <template v-slot:table-busy>
                    <PreLoader/>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- Main table element -->
            
            <!-- Pagination controls -->
            <b-row>
              <b-col md="12" lg="5">
                <b-form-group label-cols :label="$t('datatables.perpagina')">
                  <b-form-select :options="pageOptions" v-model="perPage"/>
                </b-form-group>
              </b-col>
              <b-col md="12" lg="7">
                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right"/>
              </b-col>
            </b-row>
            <!-- Pagination controls -->
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  "use strict";
  //Import store
  import {mapActions, mapGetters} from 'vuex';
  import PreLoader from '@/components/root/Preloader';

  import { getEmptyText } from '@/views/root/GetMessageTextHelper';
  
  export default {
    name: `orders-index`,
    components: {PreLoader},
    data() {
      return {
        currentPage: 1,
        perPage: 50,
        pageOptions: [50, 100, 200],
        filter: null,
        count: -1,
      };
    },
    computed: {
      fields (){
        return [
          {key: 'orderDate', label: this.$i18n.t('datatables.datum'), sortable: true},
          {key: 'number', label: this.$i18n.t('datatables.ordernummer'), sortable: true},
          {key: 'reference', label: this.$i18n.t('datatables.referentie'), sortable: true},
          {key: 'status', label: this.$i18n.t('datatables.status'), sortable: true},
        ]
      },
      ...mapGetters('carpetline', ['orders','orderStatuses']),
      sortOptions() {
        return this.fields.filter(f => f.sortable).map(f => {
          return {text: f.label, value: f.key};
        });
      },
    },
    methods: {
      ...mapActions('carpetline', ['all']),
      formatToInlineText(items) {
        var inlineText = '';
        
        if (items.length == 0) {
          return inlineText;
        }
        for (var i = 0; i < items.length; i++) {
          inlineText += items[i].fullName + ', ';
        }
        inlineText = inlineText.slice(0, -2);
        return inlineText;
      },
      onFiltered(filteredItems) {
        this.count = filteredItems.length;
        this.currentPage = 1;
      },
      onRowClicked(item) {
        this.$router.push({name: `orders:detail`, params: {orderId: item.number}});
      },
      goTo(name) {
        this.$router.push({name: `orders:${name}`});
      },
      getEmptyText,
    },
    created() {
      var vm = this;
      vm.all({
        resource: 'orders'
      })
      .then((data) => {
        vm.count = data.result.length;
      });
    },
  };
</script>
